import "core-js/modules/es7.array.includes";
import css from '@styled-system/css';
import { systemPropsFns } from '../../system/styled-system.es.js';
import styled from 'styled-components';

var nbOfLines = function nbOfLines(_ref) {
  var nbOfLines2 = _ref.nbOfLines;

  if (typeof nbOfLines2 !== "number") {
    return {};
  }

  return {
    display: "-webkit-box",
    WebkitLineClamp: nbOfLines2 || "unset",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    wordBreak: "break-word"
  };
};

var sx = function sx(props) {
  return css(props.sx)(props.theme);
};

var COMMON_PROPS = ["kind", "variant", "shape", "size"];
var Box = styled("div").withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !COMMON_PROPS.includes(prop) && defaultValidatorFn(prop);
  }
}).withConfig({
  componentId: "c98zp8-0"
})(["&&{", ";", ";", ";}"], nbOfLines, sx, systemPropsFns);
Box.displayName = "Box";
export { Box };